import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29b4121a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/favourite/_favourite.scss?vue&type=style&index=0&id=29b4121a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4121a",
  null
  
)

export default component.exports